<template>
  <div class="content">
    <!-- <img src="../assets/img/zstp/banner.png" alt="" style="width: 100%;height: 320px;"> -->
    
    <div class="industry-graph-wrapper">
      <div class="industry-graph-module">
        <div class="controls">
          <div class="control-group">
            <label>分类筛选:</label>
            <select id="categoryFilter">
              <option value="all">全部分类</option>
            </select>
          </div>
          <div class="control-group">
            <label>层级筛选:</label>
            <select id="levelFilter">
              <option value="all">全部层级</option>
              <option value="1">Level 1 - 原料开采</option>
              <option value="2">Level 2 - 材料加工</option>
              <option value="3">Level 3 - 中游制造</option>
              <option value="4">Level 4 - 系统集成</option>
              <option value="5">Level 5 - 终端应用</option>
            </select>
          </div>
          <div class="control-group">
            <label>搜索节点:</label>
            <input type="text" id="searchInput" placeholder="输入产业名称...">
          </div>
          <button class="btn" @click="resetGraph">重置视图</button>
          <button class="btn" @click="exportGraph">导出图片</button>
        </div>

        <div class="graph-container">
          <div id="industryGraph"></div>
        </div>

        <div class="stats">
          <div class="stat-item">
            <div class="stat-value" id="nodeCount">0</div>
            <div class="stat-label">产业节点</div>
          </div>
          <div class="stat-item">
            <div class="stat-value" id="linkCount">0</div>
            <div class="stat-label">关联关系</div>
          </div>
          <div class="stat-item">
            <div class="stat-value" id="categoryCount">0</div>
            <div class="stat-label">产业分类</div>
          </div>
        </div>

        <div class="legend">
          <h3>📊 图例说明</h3>
          <div class="legend-items" id="legendItems"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'zstpContent',
  data(){
    return{
      chart: null,
      graphData: null,
      originalData: null,
      categoryColors: {
        '能源原料': '#FF6B6B',
        '稀有矿产': '#4ECDC4',
        '大宗矿产': '#45B7D1',
        '非金属矿': '#96CEB4',
        '基础材料': '#FFEAA7',
        '基础化工': '#DFE6E9',
        '新型材料': '#74B9FF',
        '光伏材料': '#FD79A8',
        '新材料': '#A29BFE',
        '电子化学品': '#6C5CE7',
        '精细化工': '#00B894',
        '电子核心': '#0984E3',
        '感知层': '#00CEC9',
        '显示层': '#FDCB6E',
        '电路基材': '#E17055',
        '基础元件': '#B2BEC3',
        '电子材料': '#55EFC4',
        '光通信': '#81ECEC',
        '工业母机': '#FAB1A0',
        '自动化': '#FF7675',
        '核心零部件': '#FD79A8',
        '高端装备': '#A29BFE',
        '生产设备': '#6C5CE7',
        '基础工艺': '#74B9FF',
        '工业设备': '#00B894',
        '电池材料': '#00CEC9',
        '动力系统': '#0984E3',
        '消费终端': '#FDCB6E',
        '智能系统': '#E17055',
        '新能源': '#55EFC4',
        '汽车零部件': '#DFE6E9',
        '配套设施': '#B2BEC3',
        '中游加工': '#FFEAA7',
        '能源应用': '#74B9FF',
        '清洁能源': '#00B894',
        '能源存储': '#0984E3',
        '循环经济': '#6C5CE7',
        '低碳技术': '#A29BFE',
        '生物前沿': '#FF6B6B',
        '医药基础': '#4ECDC4',
        '高端服务': '#45B7D1',
        '生物制品': '#96CEB4',
        '医疗器械': '#FFEAA7',
        '医疗检测': '#DFE6E9',
        '医疗设备': '#74B9FF',
        '基础软件': '#FD79A8',
        '工业软件': '#A29BFE',
        '算力基础设施': '#6C5CE7',
        'AI应用': '#00B894',
        '数字安全': '#00CEC9',
        '前沿科技': '#0984E3',
        '建材': '#FDCB6E',
        '现代建筑': '#E17055',
        '下游终端': '#B2BEC3',
        '基建设施': '#55EFC4'
      }
    }
  },
  mounted(){
    this.loadECharts()
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods:{
    loadECharts() {
      if (typeof window.echarts !== 'undefined') {
        this.initGraphAfterEcharts()
        return
      }
      
      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/echarts@5.4.3/dist/echarts.min.js'
      script.onload = () => {
        this.initGraphAfterEcharts()
      }
      script.onerror = () => {
        this.$message.error('图表库加载失败，请检查网络连接')
      }
      document.head.appendChild(script)
    },
    
    async initGraphAfterEcharts() {
      try {
        await this.loadGraphData()
        this.initChart()
        this.initControls()
        this.updateStats()
        this.generateLegend()
      } catch (error) {
        console.error('初始化失败:', error)
        this.$message.error('初始化失败: ' + error.message)
      }
    },
    
    async loadGraphData() {
      try {
        // 这里需要将 tupu.json 放到 public 目录下
        const response = await fetch('/tupu.json')
        const data = await response.json()
        this.originalData = data.industry_graph
        this.graphData = JSON.parse(JSON.stringify(this.originalData))
      } catch (error) {
        console.error('加载图谱数据失败:', error)
        throw new Error('加载图谱数据失败')
      }
    },
    
    initChart() {
      const chartDom = document.getElementById('industryGraph')
      if (!chartDom) return
      
      // eslint-disable-next-line no-undef
      this.chart = window.echarts.init(chartDom)
      
      setTimeout(() => {
        this.chart.resize()
      }, 100)
      
      this.renderGraph(this.graphData)
    },
    
    renderGraph(data) {
      if (!data || !data.nodes || !data.links || !this.chart) return

      const nodes = data.nodes.map(node => ({
        id: node.id,
        name: node.name,
        category: node.category,
        level: node.level,
        symbolSize: 25 + (6 - node.level) * 8,
        itemStyle: {
          color: this.categoryColors[node.category] || '#95a5a6'
        },
        label: {
          show: true,
          fontSize: 10,
          fontWeight: 'bold'
        }
      }))

      const links = data.links.map(link => ({
        source: link.source,
        target: link.target,
        label: {
          show: true,
          formatter: link.relation,
          fontSize: 9
        },
        lineStyle: {
          curveness: 0.2,
          width: 2
        }
      }))

      const option = {
        title: {
          text: '产业链图谱',
          subtext: data.metadata?.description || '',
          top: 10,
          left: 'center',
          textStyle: {
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            if (params.dataType === 'node') {
              return `
                <strong>${params.data.name}</strong><br/>
                分类: ${params.data.category}<br/>
                层级: Level ${params.data.level}<br/>
                ID: ${params.data.id}
              `
            } else if (params.dataType === 'edge') {
              return `
                ${params.data.source} → ${params.data.target}<br/>
                关系: ${params.data.label.formatter}
              `
            }
          }
        },
        animationDuration: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [{
          type: 'graph',
          layout: 'force',
          data: nodes,
          links: links,
          roam: true,
          draggable: true,
          focusNodeAdjacency: true,
          force: {
            repulsion: 400,
            gravity: 0.1,
            edgeLength: 150,
            layoutAnimation: true
          },
          emphasis: {
            focus: 'adjacency',
            lineStyle: {
              width: 4
            },
            label: {
              fontSize: 12
            }
          },
          lineStyle: {
            color: 'source',
            curveness: 0.2,
            opacity: 0.6
          }
        }]
      }

      this.chart.setOption(option, true)
      
      setTimeout(() => {
        this.chart.resize()
      }, 500)
    },
    
    initControls() {
      const categories = [...new Set(this.graphData.nodes.map(n => n.category))]
      const categoryFilter = document.getElementById('categoryFilter')
      categories.forEach(cat => {
        const option = document.createElement('option')
        option.value = cat
        option.textContent = cat
        categoryFilter.appendChild(option)
      })

      categoryFilter.addEventListener('change', () => {
        this.filterGraph()
      })

      document.getElementById('levelFilter').addEventListener('change', () => {
        this.filterGraph()
      })

      document.getElementById('searchInput').addEventListener('input', () => {
        this.filterGraph()
      })
    },
    
    filterGraph() {
      const categoryValue = document.getElementById('categoryFilter').value
      const levelValue = document.getElementById('levelFilter').value
      const searchValue = document.getElementById('searchInput').value.toLowerCase()

      let filteredNodes = this.originalData.nodes

      if (categoryValue !== 'all') {
        filteredNodes = filteredNodes.filter(n => n.category === categoryValue)
      }

      if (levelValue !== 'all') {
        filteredNodes = filteredNodes.filter(n => n.level === parseInt(levelValue))
      }

      if (searchValue) {
        filteredNodes = filteredNodes.filter(n => 
          n.name.toLowerCase().includes(searchValue) ||
          n.id.toLowerCase().includes(searchValue)
        )
      }

      const nodeIds = new Set(filteredNodes.map(n => n.id))
      const filteredLinks = this.originalData.links.filter(l => 
        nodeIds.has(l.source) && nodeIds.has(l.target)
      )

      this.graphData = {
        ...this.originalData,
        nodes: filteredNodes,
        links: filteredLinks
      }

      this.renderGraph(this.graphData)
      this.updateStats()
    },
    
    resetGraph() {
      document.getElementById('categoryFilter').value = 'all'
      document.getElementById('levelFilter').value = 'all'
      document.getElementById('searchInput').value = ''
      
      this.graphData = JSON.parse(JSON.stringify(this.originalData))
      this.renderGraph(this.graphData)
      this.updateStats()
    },
    
    exportGraph() {
      const url = this.chart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })
      
      const link = document.createElement('a')
      link.download = '产业链图谱.png'
      link.href = url
      link.click()
    },
    
    updateStats() {
      document.getElementById('nodeCount').textContent = this.graphData.nodes.length
      document.getElementById('linkCount').textContent = this.graphData.links.length
      
      const categories = new Set(this.graphData.nodes.map(n => n.category))
      document.getElementById('categoryCount').textContent = categories.size
    },
    
    generateLegend() {
      const legendItems = document.getElementById('legendItems')
      const categories = [...new Set(this.originalData.nodes.map(n => n.category))]
      
      categories.forEach(cat => {
        const item = document.createElement('div')
        item.className = 'legend-item'
        
        const color = document.createElement('div')
        color.className = 'legend-color'
        color.style.backgroundColor = this.categoryColors[cat] || '#95a5a6'
        
        const label = document.createElement('span')
        label.textContent = cat
        
        item.appendChild(color)
        item.appendChild(label)
        legendItems.appendChild(item)
      })
    }
  }
}
</script>
  
<style scoped>
.content{
  width: 100%;
  min-height: calc(100vh - 14px);
  background: #F5F7FA;
}

.industry-graph-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background: #F5F7FA;
}

.industry-graph-module {
  width: 100%;
  max-width: 1400px;
}

.industry-graph-module .controls {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: center;
}

.industry-graph-module .control-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.industry-graph-module .control-group label {
  font-weight: bold;
  color: #333;
}

.industry-graph-module .control-group select,
.industry-graph-module .control-group input {
  padding: 8px 12px;
  border: 2px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}

.industry-graph-module .control-group select:focus,
.industry-graph-module .control-group input:focus {
  border-color: #667eea;
}

.industry-graph-module .btn {
  padding: 8px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: transform 0.2s, box-shadow 0.2s;
}

.industry-graph-module .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.industry-graph-module .graph-container {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  padding: 20px;
  height: 700px;
  width: 100%;
}

.industry-graph-module #industryGraph {
  width: 100%;
  height: 100%;
}

.industry-graph-module .legend {
  background: white;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  margin-top: 20px;
}

.industry-graph-module .legend h3 {
  margin-bottom: 10px;
  color: #333;
  font-size: 1.2em;
}

.industry-graph-module .legend-items {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.industry-graph-module .legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.industry-graph-module .legend-color {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.industry-graph-module .stats {
  background: white;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
}

.industry-graph-module .stat-item {
  text-align: center;
}

.industry-graph-module .stat-value {
  font-size: 2em;
  font-weight: bold;
  color: #667eea;
}

.industry-graph-module .stat-label {
  color: #666;
  margin-top: 5px;
}
</style>